import { render } from "./ParticipantInfo.vue?vue&type=template&id=2b466d4f&ts=true"
import script from "./ParticipantInfo.vue?vue&type=script&lang=ts"
export * from "./ParticipantInfo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__